/**
 * Which components Form.io actually showed the debtor.
 *
 * A form can carry several variations of the same wording, one shown per
 * condition - the ACH disclosure has one paragraph for a payment dated today and
 * another for a future date. Only the live Form.io instance knows which won:
 * conditions can be arbitrary JavaScript, so the server cannot re-evaluate them
 * later. The keys are therefore captured at submit time and posted alongside the
 * answers, which lets the staff-facing views render the same variation the debtor
 * agreed to instead of every variation at once.
 */

/**
 * Keys of every currently visible component in a rendered form, including the
 * children of panels, columns and wizard pages.
 *
 * @param formioComponent the <formio> component instance (its ViewChild ref)
 * @return the visible keys, or an empty array if the instance cannot be read -
 *         callers treat that as "unknown" and fall back to showing everything
 */
export function collectVisibleComponentKeys(formioComponent: any): string[] {
  const instance = formioComponent?.formio;
  if (!instance || typeof instance.everyComponent !== 'function') {
    return [];
  }
  const keys: string[] = [];
  instance.everyComponent((component: any) => {
    const key = component?.component?.key;
    // 'visible' is Form.io's own resolved visibility, conditions included. Only
    // an explicit false counts as hidden, so an older build that does not expose
    // the getter reports everything visible rather than nothing.
    if (key && component.visible !== false && keys.indexOf(key) === -1) {
      keys.push(key);
    }
  });
  return keys;
}
